<template>
  <div>
    <component
      v-if="userFetched"
      :is="'EditIncidentForm'"
      :incidentDetails="incidentDetails"
      :incidentId="incidentId"
      :username="username"
      :user_id="user_id"
      :user_groups="user_groups"
      @refresh-incident="handleRefreshIncident"
      :key="refreshKey"
    />
  </div>
</template>

<script>
import axios from 'axios'
import EditIncidentForm from './EditIncidentForm.vue'

export default {
  components: { EditIncidentForm },
  data() {
    return {
      incidentDetails: null,
      incidentId: null,
      username: '',
      user_id: null,
      user_groups: [],
      permissions: [],
      userFetched: false,
      refreshKey: 0,
    }
  },
  async mounted() {
    this.incidentId = this.$route.params.incidentId
    this.loadPermissions()
    if (!this.canViewIncident) {
      this.$router.push({ name: 'MainPanel' })
      return
    }
    await this.fetchIncidentDetails()
    await this.fetchCurrentUser()
  },
  computed: {
    canViewIncident() {
      return this.hasAnyPerm(['maintenance.view_incident', 'ui_access_maintenance_incidents_card'])
    },
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false
      return perms.some((perm) => this.hasPerm(perm))
    },
    async fetchIncidentDetails() {
      try {
        const apiDirectory = process.env.API_DIRECTORY
        const response = await axios.get(`${apiDirectory}/unit-incidents/${this.incidentId}/`)
        this.incidentDetails = response.data
      } catch (error) {
        console.error('Failed to fetch incident details:', error)
      }
    },
    fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      return axios
        .get(`${apiDirectory}/current-user/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('authToken')}`,
          },
        })
        .then((response) => {
          this.user_groups = response.data.groups
          this.user_id = response.data.id
          this.userFetched = true
        })
        .catch((error) => {
          console.error('There was an error fetching the user data:', error)
        })
    },
    async handleRefreshIncident() {
      await Promise.all([this.fetchIncidentDetails(), this.fetchCurrentUser()])
      this.refreshKey += 1
    },
  },
}
</script>
